import { Tooltip, Button } from 'antd';
import { WorkorderChecklistItemType } from '../../WorkorderChecklistProvider/WorkorderChecklistProvider.types';
import { useWorkorderChecklistContext } from '../../WorkorderChecklistProvider';
import { useCallback } from 'react';

interface Props {
  tooltipMessage?: string;
  disabled: boolean;
  loading: boolean;
  companyId?: number;
}

export default function ChecklistPrintButton(props: Props) {
  const { checklistItemId, checklistItemType } = useWorkorderChecklistContext();

  const redirectToPrint = useCallback(() => {
    let params;

    if (!props.companyId) return;

    if (checklistItemType === WorkorderChecklistItemType.Diagnostic) {
      params = new URLSearchParams({
        diagnosticId: checklistItemId.toString(),
        companyId: props.companyId?.toString(),
      });
    } else {
      params = new URLSearchParams({
        workOrderComplementId: checklistItemId.toString(),
        companyId: props.companyId?.toString(),
      });
    }

    window.open(
      checklistItemType === WorkorderChecklistItemType.Diagnostic
        ? `${
            window.location.origin
          }/publicReports/checklist?${params.toString()}`
        : `${
            window.location.origin
          }/publicReports/checklist?${params.toString()}`,
      '_blank',
    );
  }, [props.companyId]);

  return (
    <>
      <Tooltip title={props.tooltipMessage}>
        <Button
          type="primary"
          block
          disabled={props.disabled}
          loading={props.loading}
          onClick={redirectToPrint}
        >
          Imprimir
        </Button>
      </Tooltip>
    </>
  );
}
